import React, { useState } from "react";
import Textfield from "../textfield";
// import 'react-datepicker/dist/react-datepicker.css';

function DateRangePicker({
	className,
	onChange,
	startDate,
	endDate,
	dType = "date",
	startDateName = "signupDateFrom",
	endDateName = "signupDateInto",
	min = "2021-01-01",
	max = new Date().toISOString().split("T")[0],
	maxEnd,
	readOnlyInput = false,
}) {
	//   const handleStartDateChange = (date) => {
	//     setStartDate(date);
	//   };

	//   const handleEndDateChange = (date) => {
	//     setEndDate(date);
	//   };

	return (
		<div className={`grid grid-cols-2 gap-2 ${className}`}>
			<div className="flex gap-2">
				<p className="col-span-1 my-auto">Start: </p>
				<Textfield
					type={dType}
					value={startDate}
					onChange={onChange}
					classNameParent="col-span-2 w-full"
					name={startDateName}
					min={min}
					max={max}
					readOnlyInput={readOnlyInput}
				/>
			</div>
			<div className="flex gap-2">
				<p className="col-span-1 my-auto">End: </p>
				<Textfield
					type={dType}
					value={endDate}
					onChange={onChange}
					classNameParent="col-span-2 w-full"
					name={endDateName}
					min={min}
					max={maxEnd}
					readOnlyInput={readOnlyInput}
				/>
			</div>
		</div>
	);
}

export default DateRangePicker;
